import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHandlerFn,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { AuthUtils } from './auth.utils';
import { SnackbarService } from 'src/app/shared/services/snackbar/snack.service';
import { LoadingService } from 'src/app/shared/services/loading/loading.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(
    private _authService: AuthService,
    private _snackbarService: SnackbarService,
    private loadingService: LoadingService,
  ) {}

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loadingService.setLoading(this.requests.length > 0);
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Is request is to assets folder, return the request
    if (req.url.includes('assets')) {
      return next.handle(req);
    }

    this.loadingService.setLoading(true);
    let newReq = req.clone();

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.

    if (this._authService.accessToken && !AuthUtils.isTokenExpired(this._authService.accessToken)) {
      newReq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + this._authService.accessToken),
      });
    }

    return next.handle(newReq).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
          }
        },
        () => {
          this.removeRequest(req);
        },
      ),
      catchError((error) => {
        // Catch "401 Unauthorized" responses
        if (error.error.show) {
          this._snackbarService.open('error', error.error.message, '', 5000);
        }

        return throwError(error);
      }),
    );
  }
}
